import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { BrandingProvider } from "@/lib/branding";
import { Toaster } from "sonner";
import ConnectionMonitor from "@/components/ConnectionMonitor";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SharePage from "@/pages/SharePage";
import DashboardPage from "@/pages/DashboardPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import UsersPage from "@/pages/UsersPage";
import InviteAcceptPage from "@/pages/InviteAcceptPage";
import AdminPortalPage from "@/pages/AdminPortalPage";
import TeamPage from "@/pages/TeamPage";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="space-y-3 text-center">
          <div className="w-10 h-10 border-2 border-zinc-200 border-t-[hsl(var(--primary))] rounded-full animate-spin mx-auto" />
          <p className="label-eyebrow">Loading workspace</p>
        </div>
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && user !== false) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BrandingProvider>
            <Toaster position="top-right" richColors closeButton />
            <ConnectionMonitor />
            <Routes>
              <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
              <Route path="/signup" element={<PublicOnly><SignupPage /></PublicOnly>} />
              <Route path="/forgot-password" element={<PublicOnly><ForgotPasswordPage /></PublicOnly>} />
              <Route path="/reset-password" element={<PublicOnly><ResetPasswordPage /></PublicOnly>} />
              <Route path="/register" element={<Navigate to="/signup" replace />} />
              <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
              <Route path="/projects" element={<Protected><ProjectsPage /></Protected>} />
              <Route path="/projects/:id" element={<Protected><ProjectDetailPage /></Protected>} />
              <Route path="/users" element={<Protected><UsersPage /></Protected>} />
              <Route path="/team" element={<Protected><TeamPage /></Protected>} />
              <Route path="/admin" element={<Protected><AdminPortalPage /></Protected>} />
              <Route path="/invite/:token" element={<InviteAcceptPage />} />
              <Route path="/share/:token" element={<SharePage />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrandingProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
